export default __webpack_public_path__ + "static/verheyen-51b693b6cdb47ae425cb712d32c815cf.jpg";